module.exports = __webpack_public_path__ + "92b3cb5cbaac6fc5f4b35f435dee2152.png";